import { LOGIN_REQUEST, LOGIN_REQUEST_ERROR, LOGIN_REQUEST_SUCCESS, REDIRCT_LOGIN } from './Constant';

// userReducer.js
const initialState = {
    user: null,
    loading: false,
    error: null,
};
  
export const loginReducer = (state = initialState, action) => {
    switch (action.type) {
    case LOGIN_REQUEST:        
        return { ...state, loading: true };
    case LOGIN_REQUEST_SUCCESS:
        return { ...state, loading: false};
    case LOGIN_REQUEST_ERROR:
        return { ...state, loading: false, error: action.payload };
    case REDIRCT_LOGIN :
        return { ...state, redirectUrl: action.payload};
    default:
        return state;
    }
};
  